import { createGenerateClassName } from '@material-ui/core';
import { StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import { DefaultTheme } from '@material-ui/styles';
import { useLocation } from 'react-router-dom';
import { WbCardContentStub, WbCardStub } from './components/WbStubs';
import DashboardCard from './components/Cards/DashboardCard';
import ProjectCard from './components/Cards/ProjectCard';

interface Props {
  theme: DefaultTheme;
  descriptor: any;
  token: string;
  initialPath: string;
}

const generateClassName = createGenerateClassName({ productionPrefix: 'qdb' });

function ViewSwitch({ descriptor, token, initialPath }: { descriptor: any; token: string; initialPath: string }) {
  if (initialPath.endsWith('/assurance')) {
    return <ProjectCard descriptor={descriptor} token={token} />;
  }
  return <DashboardCard token={token} />;
}

function App({ theme, descriptor, token, initialPath }: Props) {
  return (
    <StylesProvider injectFirst generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <WbCardStub title={document.title}>
          <WbCardContentStub>
            <ViewSwitch descriptor={descriptor} token={token} initialPath={initialPath} />
          </WbCardContentStub>
        </WbCardStub>
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
